'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataAccess = function () {
  function DataAccess(securityManager, localStorage, externalStorage, message) {
    var _this = this;

    _classCallCheck(this, DataAccess);

    this.timeout = null;
    this.waitTimeout = 3000;
    this.externalStorageOnly = true;
    this.securityManager = securityManager;
    this.localStorage = localStorage;
    this.externalStorage = externalStorage;
    this.message = message;

    this.closed = function () {
      _this.message('down');
    };

    this.localStorage.onclose = this.closed;
    this.localStorage.onblocked = this.closed;
    this.localStorage.onversionchange = this.closed;
    this.externalStorage.onclose = this.closed;
  }

  _createClass(DataAccess, [{
    key: 'init',
    value: function init(username, password) {
      var _this2 = this;

      this.localStorage.open().then(function () {
        _this2.externalStorage.open(username, password).then(function () {
          _this2.message('up');
        }, function () {
          _this2.message('down');
        });
      }, function () {
        _this2.message('down');
      });
    }
  }, {
    key: 'setDataKey',
    value: function setDataKey(passphrase) {
      var _this3 = this;

      this.securityManager.setDataKey(passphrase).then(function () {
        _this3.message('dataKeySet');
      }, function (error) {
        _this3.message('error', error.stack);
      });
    }
  }, {
    key: 'setCredentials',
    value: function setCredentials(username, password) {
      this.externalStorage.setCredentials(username, password);
      this.message('credentialsSet');
    }
  }, {
    key: 'isCurrentPassword',
    value: function isCurrentPassword(password) {
      return this.externalStorage.status(password);
    }
  }, {
    key: 'externalChangePassword',
    value: function externalChangePassword(password) {
      return this.externalStorage.changePassword(password);
    }
  }, {
    key: 'localStatus',
    value: function localStatus() {
      return this.localStorage.status();
    }
  }, {
    key: 'externalStatus',
    value: function externalStatus() {
      return this.externalStorage.status();
    }
  }, {
    key: 'read',
    value: function read() {
      var _this4 = this;

      this.message('readPending');

      this.externalStorage.read().then(function (data) {
        _this4.securityManager.decryptData(data).then(function (modelData) {
          if (modelData) {
            _this4.localStorage.write(JSON.parse(modelData)).then(function () {
              _this4.message('read');
            }, function (error) {
              _this4.message('readFailed', error);
            });
          } else {
            _this4.message('read');
          }
        }, function (error) {
          _this4.message('readFailed', error);
        });
      }, function (error) {
        _this4.message('readFailed', error);
      });
    }
  }, {
    key: 'write',
    value: function write() {
      var _this5 = this;

      this.message('writePending');

      this.localStorage.read().then(function (modelData) {
        _this5.securityManager.encryptData(JSON.stringify(modelData ? modelData : {})).then(function (data) {
          _this5.externalStorage.write(data).then(function () {
            _this5.message('write');
          }, function (error) {
            _this5.timeout = setTimeout(_this5.autoWrite, _this5.waitTimeout);
            _this5.message('writeFailed', error ? error.stack : undefined);
          });
        }, function (error) {
          _this5.message('writeFailed', error ? error.stack : undefined);
        });
      }, function (error) {
        _this5.message('writeFailed', error ? error.stack : undefined);
      });
    }
  }, {
    key: 'get',
    value: function get(type, uuid) {
      if (this.externalStorageOnly) {
        return this.externalStorage.get({ name: type, uncached: type === 'files' }, uuid);
      }

      return this.localStorage.get({ name: type, uncached: type === 'files' }, uuid);
    }
  }, {
    key: 'put',
    value: function put(type, data) {
      clearTimeout(this.timeout);

      if (this.externalStorageOnly) {
        return this.externalStorage.put({ name: type, uncached: type === 'files' }, data);
      }

      return this.localStorage.put({ name: type, uncached: type === 'files' }, data);
    }
  }, {
    key: 'delete',
    value: function _delete(type, uuid) {
      clearTimeout(this.timeout);

      if (this.externalStorageOnly) {
        return this.externalStorage.delete({ name: type, uncached: type === 'files' }, uuid);
      }

      return this.localStorage.delete({ name: type, uncached: type === 'files' }, uuid);
    }
  }, {
    key: 'autoWrite',
    value: function autoWrite() {
      this.write();
    }
  }, {
    key: 'resolveSingle',
    value: function resolveSingle(type, data, recursive) {
      return new Promise(function (resolve, reject) {
        var model = window.PRIM.modelMapper.initToModel(type, data);

        switch (type) {
          default:
            resolve(model);
            break;
          case 'positions':
            if (recursive) {
              var promises = 0;
              if (model.values.person_id) {
                promises++;
                window.PRIM.dataAccess.resolve('people', model.values.person_id, true).then(function (person) {
                  model.person = person;
                  promises--;

                  if (promises === 0) {
                    resolve(model);
                  }
                }, function () {
                  promises--;

                  if (promises === 0) {
                    reject();
                  }
                });
              }
              if (model.values.location_id) {
                promises++;
                window.PRIM.dataAccess.resolve('locations', model.values.location_id, true).then(function (location) {
                  model.location = location;
                  promises--;

                  if (promises === 0) {
                    resolve(model);
                  }
                }, function () {
                  promises--;

                  if (promises === 0) {
                    reject();
                  }
                });
              }
            } else {
              resolve(model);
            }
            break;
          case 'educations':
            if (model.values.location_id && recursive) {
              window.PRIM.dataAccess.resolve('locations', model.values.location_id, true).then(function (location) {
                model.location = location;
                resolve(model);
              }, reject);
            } else {
              resolve(model);
            }
            break;
          case 'organisations':
            if (model.values.location_id && recursive) {
              window.PRIM.dataAccess.resolve('locations', model.values.location_id, false).then(function (location) {
                model.location = location;
                resolve(model);
              }, reject);
            } else {
              resolve(model);
            }
            break;
          case 'locations':
            if (model.values.organisation_id && recursive) {
              window.PRIM.dataAccess.resolve('organisations', model.values.organisation_id, true).then(function (organisation) {
                model.organisation = organisation;
                resolve(model);
              }, reject);
            } else {
              resolve(model);
            }
            break;
          case 'relationships':
            if (recursive) {
              var _promises = 0;
              if (model.values.person_id) {
                _promises++;
                window.PRIM.dataAccess.resolve('people', model.values.person_id, true).then(function (person) {
                  model.person = person;
                  _promises--;

                  if (_promises === 0) {
                    resolve(model);
                  }
                }, function () {
                  _promises--;

                  if (_promises === 0) {
                    reject();
                  }
                });
              }

              if (model.values.target_id) {
                _promises++;
                window.PRIM.dataAccess.resolve('people', model.values.target_id, true).then(function (target) {
                  model.target = target;
                  _promises--;

                  if (_promises === 0) {
                    resolve(model);
                  }
                }, function () {
                  _promises--;

                  if (_promises === 0) {
                    reject();
                  }
                });
              }
            } else {
              resolve(model);
            }
            break;
        }
      });
    }
  }, {
    key: 'resolve',
    value: function resolve(type, id, recursive, indexkey) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (id && !indexkey) {
          window.PRIM.dataAccess.get(type, id).then(function (data) {
            _this6.resolveSingle(type, data, recursive).then(resolve, reject);
          }, reject);
        } else {
          window.PRIM.dataAccess.get(type).then(function (data) {
            var results = void 0;

            if (indexkey) {
              results = data.filter(function (item) {
                return item[indexkey] === id;
              });
            } else {
              results = data;
            }

            var promises = 0;
            var models = [];

            results.forEach(function (item) {
              promises++;
              _this6.resolveSingle(type, item, recursive).then(function (model) {
                models.push(model);

                promises--;
                if (promises === 0) {
                  resolve(models);
                }
              }, function () {
                promises--;
                if (promises === 0) {
                  resolve(models);
                }
              });
            });
          });
        }
      });
    }
  }]);

  return DataAccess;
}();

exports.default = DataAccess;


//////////////////
// WEBPACK FOOTER
// ./js/lib/DataAccess.js
// module id = 5
// module chunks = 0